
import { IPublicClientApplication, PublicClientApplication, InteractionType, BrowserCacheLocation, LogLevel, EventMessage, EventType } from '@azure/msal-browser';
import { MsalInterceptorConfiguration, MsalGuardConfiguration, MsalBroadcastService, MSAL_INSTANCE, MSAL_GUARD_CONFIG, MSAL_INTERCEPTOR_CONFIG, MsalService, MsalInterceptor, MsalGuard } from '@azure/msal-angular';
import { HTTP_INTERCEPTORS, provideHttpClient, withFetch, withInterceptorsFromDi } from "@angular/common/http";
import { EnvironmentProviders, Provider } from "@angular/core";
import { ENVIRONMENT, Environment } from "./auth.tokens";
import { ApimKeyInterceptor } from "../http/ApimKeyInterceptor";
import { AuthInterceptorService } from '../http/auth-interceptor.service';
import { ErrorInterceptor } from '../http/error-interceptor.service';


function loggerCallback(logLevel: LogLevel, message: string) {
 // console.log(message);
}

// Els entorns INT/PROD comparteixen tenant, i el cache MSAL en localStorage pot barrejar-se.
// Quan canvia el clientId respecte a l'últim arrencat, netegem qualsevol residu.
function purgeStaleCacheOnEnvChange(currentClientId: string): void {
  const lastClientId = localStorage.getItem('msal-last-client-id');
  if (lastClientId && lastClientId !== currentClientId) {
    Object.keys(localStorage)
      .filter(k => k.startsWith('msal.') || k.includes('.ciamlogin.') || k.includes('login.microsoftonline'))
      .forEach(k => localStorage.removeItem(k));
    localStorage.removeItem('token');
  }
  localStorage.setItem('msal-last-client-id', currentClientId);
}

function MSALInstanceFactory(opts: Environment): IPublicClientApplication {
  purgeStaleCacheOnEnvChange(opts.msalConfig.auth.clientId);

  return new PublicClientApplication({
    auth: {
      clientId: opts.msalConfig.auth.clientId,
      authority: opts.msalConfig.auth.authority,
      redirectUri: '/',
      postLogoutRedirectUri: '/'
    },
    cache: {
      cacheLocation: BrowserCacheLocation.LocalStorage
    },
    system: {
      allowNativeBroker: false, // Disables WAM Broker
      loggerOptions: {
        loggerCallback,
        logLevel: LogLevel.Info,
        piiLoggingEnabled: false
      }
    }
  });
}

function MSALInterceptorConfigFactory(opts: Environment): MsalInterceptorConfiguration {
  const protectedResourceMap = new Map<string, Array<string>>();
  protectedResourceMap.set(opts.apiConfig.uri, opts.apiConfig.scopes);

  return {
    interactionType: InteractionType.Redirect,
    protectedResourceMap
  };
}

function MSALGuardConfigFactory(opts: Environment): MsalGuardConfiguration {
  return { 
    interactionType: InteractionType.Redirect,
    authRequest: {
      scopes: [...opts.apiConfig.scopes]
    },
    loginFailedRoute: '/error'
  };
}

export function provideCoreAuth(options: Environment): Array<Provider | EnvironmentProviders> {
  return [
    provideHttpClient(withInterceptorsFromDi(), withFetch()),
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptorService, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ApimKeyInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: MsalInterceptor, multi: true },
    { provide: ENVIRONMENT, useValue: options },
    { provide: MSAL_INSTANCE, useFactory: MSALInstanceFactory, deps: [ENVIRONMENT] },
    { provide: MSAL_GUARD_CONFIG, useFactory: MSALGuardConfigFactory, deps: [ENVIRONMENT] },
    { provide: MSAL_INTERCEPTOR_CONFIG, useFactory: MSALInterceptorConfigFactory, deps: [ENVIRONMENT] },
    MsalService,
    MsalGuard,
    MsalBroadcastService,
  ];
}